import { Students } from "../students"

export const WorkForceEmployees = ({pageSwap, goToScreen}) => {
    return(
        <Students titleScreen={"Werknemers"} pageSwap={pageSwap} goToScreen={goToScreen}/>
    )
}